import { toast } from "react-toastify";
import { AVISOS_API } from "../views/MainLayout/components/shared/services/avisos";
import { setErrorMessage } from "../views/MainLayout/components/shared/helpers/functionalities";


const initialAvisos = []

export const avisosReducer = (state = initialAvisos, action) => {
    switch(action.type){
        case "avisos/fullfilled": {            
            return action.payload;
        }
        default:
            return state
    }
}

export const fetchAvisos = (page, search) => async dispatch => {
    dispatch({ type: 'loading/set', payload: true })

    try {
        const response = await AVISOS_API.get(page, search)
        const data = await response.data;
        dispatch({ type: 'avisos/fullfilled', payload: data })
    } catch (e) {
        toast.error(setErrorMessage(e))
    } finally {
        dispatch({ type: 'loading/set', payload: false })
    }
}